import { render, staticRenderFns } from "./consume-record-dialog.vue?vue&type=template&id=de4891e0&scoped=true"
import script from "./consume-record-dialog.vue?vue&type=script&lang=ts"
export * from "./consume-record-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4891e0",
  null
  
)

export default component.exports